var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "over_layout" }, [
    _c("section", { staticClass: "upgrade" }, [
      _c(
        "a",
        {
          staticStyle: { cursor: "pointer" },
          on: {
            click: function($event) {
              return _vm.$store.commit("paymentModal", true)
            }
          }
        },
        [
          _vm._v(
            "\n            " + _vm._s(_vm.$store.getters.t("create_resume"))
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "contact_page" }, [
      _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "pages_header" }, [
          _c("div", { staticClass: "lines" }, [
            _c("h1", {
              domProps: {
                innerHTML: _vm._s(_vm.$store.getters.t("policy_title"))
              }
            })
          ]),
          _vm._v(" "),
          _vm.$store.getters.locale === "en"
            ? _c("div", { staticClass: "text_area" }, [_vm._m(0)])
            : _vm._e(),
          _vm._v(" "),
          _vm.$store.getters.locale === "ru"
            ? _c("div", { staticClass: "text_area" }, [_vm._m(1)])
            : _vm._e(),
          _vm._v(" "),
          _vm.$store.getters.locale === "am"
            ? _c("div", { staticClass: "text_area" }, [_vm._m(2)])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [
        _vm._v("1. Generalities\n                                "),
        _c("ul", [
          _c("li", [
            _vm._v(
              '\n                                        1.1. LLC "Creative Web" (hereinafter – the Operator) puts the observance of the rights and freedoms\n                                        of citizens one of the most important conditions for the implementation of its activities.\n                                    '
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                                        1.2. The Operator's policy regarding the processing of personal data (hereinafter — the Policy)\n                                        applies to all information that the Operator may receive about visitors to the website cvweb.ru\n                                        Personal data are processed in accordance with the legislation of the Republic of Armenia.\n                                    "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                                        1.3. This privacy Policy applies only to the sites www.cvweb.ru. the Site does not control and is\n                                        not responsible for third party sites to which the user can click on the links available on the\n                                        sites www.cvweb.ru.\n                                    "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "\n                                2. Basic concepts used in politics\n                                "
        ),
        _c("ul", [
          _c("li", [
            _vm._v(
              "\n                                        2.1. Website - a set of graphics and information materials, as well as computer programs and\n                                        databases that ensure their availability on the Internet at a network address cvweb.ru\n                                    "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("         2.2. User – any visitor to the website cvweb.ru")
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "                2.3. Personal data – any information relating to the User of the website cvweb.ru"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "  2.4. Processing of personal data - any action with personal data performed using computers, as well\n                                        as without their use"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "\n                                3. Information to be processed\n                                "
        ),
        _c("ul", [
          _c("li", [_vm._v("3.1. Surname, name, patronymic")]),
          _vm._v(" "),
          _c("li", [_vm._v("• Email address")]),
          _vm._v(" "),
          _c("li", [_vm._v("• Phone number")]),
          _vm._v(" "),
          _c("li", [_vm._v("• Year, month, date and place of birth")]),
          _vm._v(" "),
          _c("li", [_vm._v("• Photos")]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "* Address of the actual place of residence and registration at the place of residence and (or) at\n                                        the place of stay"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("* Information on marital status and family composition")
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              " * Information about previously held positions and seniority, military duties, military records"
            )
          ]),
          _vm._v(" "),
          _c("li", [_vm._v("* Information about education, etc.")]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              '  3.2. Also on the website, the collection and processing of anonymous data about visitors (including\n                                        "cookies") through the services of Internet statistics (Yandex Metric and Google Analytics and\n                                        others).'
            )
          ]),
          _vm._v(" "),
          _c("li")
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "  4. Purposes of personal data processing\n                                "
        ),
        _c("ul", [
          _c("li", [
            _vm._v(
              "4.1. Providing the User with access to the services, information and / or materials contained on\n                                        the website.\n                                    "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "4.2. Provision of access and transfer of data to other users of the site."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "4.3. Confirmation of the accuracy and completeness of personal data provided by the User."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              " 4.4. Providing the User with effective customer and technical support in case of problems related\n                                        to the use of the Site."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              '4.5. The operator has the right to send notifications to the User about new products and services,\n                                        special offers and various events. The user can always refuse to receive information messages by\n                                        going to the "settings" section.'
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v("  5. Final provision\n                                "),
        _c("ul", [
          _c("li", [
            _vm._v(
              "  5.1. This Policy is subject to changes and additions, if necessary, including in the case of new legislative acts and special regulations on the processing and protection of personal data."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "5.2. This Policy is an internal document of Creative Web LLC and is subject to posting on the\n                                        website cvweb.ru."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "5.3. In case of changes, such changes shall be communicated to an unlimited number of persons by\n                                        posting on the official website cvweb.ru. policies subject to such changes. The new policy comes\n                                        into force from the moment it is posted on the Site."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "5.4. The user can receive any clarifications on issues of interest relating to the processing of\n                                        his personal data by contacting the Operator using the e-mail specified on the site cvweb.ru."
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [
        _vm._v("1. Общие положения\n                            "),
        _c("ul", [
          _c("li", [
            _vm._v(
              "1.1. ООО «Креатив Веб» (далее по тексту – Оператор) ставит соблюдение прав и свобод граждан одним\n                                    из важнейших условий осуществления своей деятельности."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "1.2. Политика Оператора в отношении обработки персональных данных (далее по тексту — Политика)\n                                    применяется ко всей информации, которую Оператор может получить о посетителях веб-сайта cvweb.ru\n                                    Персональные данные обрабатываются в соответствии с законодательством Республики Армения."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "1.3. Настоящая Политика конфиденциальности применяется только к сайтам www.cvweb.ru. Сайт не\n                                    контролирует и не несет ответственности за сайты третьих лиц, на которые пользователь может перейти\n                                    по ссылкам, доступным на сайтах www.cvweb.ru."
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "2. Основные понятия, используемые в политике\n                            "
        ),
        _c("ul", [
          _c("li", [
            _vm._v(
              "2.1. Веб-сайт - совокупность графических и информационных материалов, а также программ для ЭВМ и\n                                    баз данных, обеспечивающих их доступность в сети интернет по сетевому адресу cvweb.ru"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("2.2. Пользователь – любой посетитель веб-сайта cvweb.ru")
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "2.3. Персональные данные – любая информация, относящаяся к Пользователю веб-сайта cvweb.ru"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "2.4. Обработка персональных данных - любое действие с персональными данными, совершаемые с\n                                    использованием ЭВМ, равно как и без их использования"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "3. Сведения, подлежащие обработке\n                            "
        ),
        _c("ul", [
          _c("li", [_vm._v(" 3.1. Фамилия, имя, отчество")]),
          _vm._v(" "),
          _c("li", [_vm._v("• Электронный адрес")]),
          _vm._v(" "),
          _c("li", [_vm._v("• Номера телефонов")]),
          _vm._v(" "),
          _c("li", [_vm._v("• Год, месяц, дата и место рождения")]),
          _vm._v(" "),
          _c("li", [_vm._v("• Фотографии")]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "• Адрес фактического места проживания и регистрации по месту жительства и (или) по месту пребывания"
            )
          ]),
          _vm._v(" "),
          _c("li", [_vm._v("• Сведения о семейном положении и составе семьи")]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "• Cведения о занимаемых ранее должностях и стаже работы, воинской обязанности, воинском учете"
            )
          ]),
          _vm._v(" "),
          _c("li", [_vm._v("• Сведения об образовании и др.")]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "3.2. Также на сайте происходит сбор и обработка обезличенных данных о посетителях (в т.ч. файлов\n                                    «cookie») с помощью сервисов интернет-статистики (Яндекс Метрика и Гугл Аналитика и других)."
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "4. Цели обработки персональных данных\n                            "
        ),
        _c("ul", [
          _c("li", [
            _vm._v(
              "4.1. Предоставление доступа Пользователю к сервисам, информации и/или материалам, содержащимся на\n                                    веб-сайте."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "4.2. Предоставление доступа и передача данных другим Пользователям сайта."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "4.3. Подтверждение достоверности и полноты персональных данных, предоставленных Пользователем."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "4.4. Предоставление Пользователю эффективной клиентской и технической поддержки при возникновении\n                                    проблем, связанных с использованием Сайта."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "4.5. Оператор имеет право направлять Пользователю уведомления о новых продуктах и услугах,\n                                    специальных предложениях и различных событиях. Пользователь всегда может отказаться от получения\n                                    информационных сообщений, зайдя в раздел «настройки»."
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v("5. Заключительные положения\n                            "),
        _c("ul", [
          _c("li", [
            _vm._v(
              "5.1. Настоящая Политика подлежит при необходимости изменению, дополнению, в т.ч. в случае появления\n                                    новых законодательных актов и специальных нормативных документов по обработке и защите персональных\n                                    данных."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "5.2. Настоящая Политика является внутренним документом ООО «Креатив Веб» и подлежит размещению на\n                                    сайте cvweb.ru."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "5.3. В случае изменений, доведение до неограниченного круга лица таких изменений осуществляется\n                                    посредством размещения на официальном сайте cvweb.ru. политики с учетом таких изменений. Новая\n                                    политика вступает в силу с момента ее размещения на Сайте."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              " 5.4. Пользователь может получить любые разъяснения по интересующим вопросам, касающимся обработки\n                                    его персональных данных, обратившись к Оператору с помощью электронной почты, указанной на сайте\n                                    cvweb.ru."
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [
        _vm._v("  1. Ընդհանուր դրույթներ\n                            "),
        _c("ul", [
          _c("li", [
            _vm._v(
              "1.1. «ԿՐԵԱՏԻՎ ՎԵԲ» ՍՊԸ (այսուհետ, Օպերատոր) գործունեության իրականացման\n                                    ամենակարևոր պայմաններից մեկը քաղաքացիների իրավունքների և ազատությունների պահպանումն է:"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "  1.2. Օպերատորի անձնական տվյալների մշակման քաղաքականությունը (այսուհետ `Քաղաքականություն) վերաբերում\n                                        է այն բոլոր տեղեկություններին, որը Օպերատորը կարող է ստանալ cvweb.ru կայքի այցելուներից։ Անձնական\n                                        տվյալները մշակվում են Հայաստանի Հանրապետության օրենսդրությանը համապատասխան:"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "1.3. Սույն գաղտնիության քաղաքականությունը վերաբերում է միայն www.cvweb.ru կայքերին: Կայքը չի\n                                    վերահսկում և պատասխանատվություն չի կրում երրորդ անձանց կայքերի համար, որոնց օգտատերը կարող է անցում\n                                    կատարել www.cvweb.ru կայքերում տեղադրված հղումներով:"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "  2. Քաղաքականության մեջ կիրառվող հիմնական հասկացությունները\n                            "
        ),
        _c("ul", [
          _c("li", [
            _vm._v(
              "2.1. Կայքը `գրաֆիկական և տեղեկատվական նյութերի, ինչպես նաև համակարգչային ծրագրերի\n                                    և տվյալների բազաների հավաքածու է, որոնք ապահովում են հասանելիությունը ինտերնետում cvweb.ru հասցեով:"
            )
          ]),
          _vm._v(" "),
          _c("li", [_vm._v("2.2. Օգտատեր՝ cvweb.ru կայքի ցանկացած այցելու։")]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "2.3. Անձնական տվյալներ ` cvweb.ru Կայքի օգտատիրոջը վերաբերող ցանկացած տեղեկություն։"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "2.4. Անձնական տվյալների մշակում `ցանկացած գործողություն անձնական տվյալների հետ, կատարված համակարգչի\n                                    միջոցով, ինչպես նաև առանց դրա օգտագործման։"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "3. Մշակման ենթակա տեղեկատվություն\n                            "
        ),
        _c("ul", [
          _c("li", [
            _vm._v(
              "  3.1 Ազգանուն, Անուն, Հայրանուն • Էլ. Հասցե • Հեռախոսահամարներ • Ծննդյան տարին,\n                                    ամսաթիվը, վայրը • Լուսանկարներ • Փաստացի բնակության հասցեն և բնակության վայրի գրանցման հասցեն •\n                                    Տեղեկություններ ամուսնական կարգավիճակի և ընտանեկան կազմի վերաբերյալ • Տեղեկություններ նախորդ\n                                    պաշտոնների և աշխատանքային փորձի, զինվորական պարտքի, զինվորական հաշվառման մասին • Կրթության մասին\n                                    տեղեկություններ և այլն:"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "3.2. Կայքում նաև կատարվում է այցելուների ապանձնավորված տվյալների\n                                    հավաքագրումը և մշակումը (ներառյալ ֆայլերը), ինտերնետային վիճակագրական ծառայությունների միջոցով\n                                    (Yandex Metrika և Google Analytics և այլն):"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "4. Անձնական տվյալների մշակման նպատակները\n                            "
        ),
        _c("ul", [
          _c("li", [
            _vm._v(
              "4.1. Կայքում ծառայությունների, տեղեկատվության և / կամ նյութերի օգտագործման հասանելիությունն\n                                    օգտատիրոջ համար ապահովելը:"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              " 4.2. Կայքի այլ օգտատերերին տվյալների հասանելիության տրամադրում և անհրաժեշտության դեպքում տվյալների\n                                    փոխանցում:"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "4.3. Օգտատիրոջ կողմից տրամադրված անձնական տվյալների ճշգրտության և ամբողջականության հաստատում:"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "4.4. Օգտատերին արդյունավետ հաճախորդին և տեխնիկական աջակցության տրամադրում կայքի օգտագործման հետ\n                                    կապված խնդիրների առաջացման դեպքում։"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "4.5. Օպերատորն իրավունք ունի ծանուցում ուղարկել օգտատիրոջը նոր ապրանքների և ծառայությունների,\n                                    հատուկ առաջարկների և տարբեր միջոցառումների մասին: Օգտատերը միշտ կարող է հրաժարվել տեղեկատվական\n                                    հաղորդագրություններ ստանալուց ` մտնելով «Կարգավորումներ» բաժին:"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v("  5. Վերջնական դրույթներ\n                            "),
        _c("ul", [
          _c("li", [
            _vm._v(
              "5.1. Այս քաղաքականությունը ենթակա է փոփոխման\n                                    անհրաժեշտության դեպքում, լրացման անձնական տվյալների մշակման և պահպանության վերաբերյալ նոր\n                                    օրենսդրական ակտերի և հատուկ նորմատիվ փաստաթղթերի առաջացման դեպքում:"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "5.2. Սույն քաղաքականությունը «Creative Web» ՍՊԸ- ի ներքին փաստաթուղթն է և ենթակա է տեղադրման\n                                    cvweb.ru կայքում:"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "5.3. Փոփոխությունների դեպքում նման փոփոխություններ կատարելու իրազեկումն իրականացվում է cvweb.ru\n                                    պաշտոնական կայքում համապատասխան փոփողություններով տարբերակը տեղադրելու միջոցով: Նոր\n                                    քաղաքականությունը ուժի մեջ է մտնում Կայքում տեղադրվելու պահից:"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              " 5.4. Օգտտերը կարող է ստանալ իր անձնական տվյալների մշակման հետ կապված ցանկացած պարզաբանում `\n                                    կապնելով օպերատորի հետ cvweb.ru կայքում նշված էլեկտրոնային փոստի միջոցով:"
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4be3f677", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4be3f677","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/PolicyPage.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4be3f677","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/PolicyPage.vue
// module chunks = 0